module.exports = __webpack_public_path__ + "static/media/presov.9dcea1c1.png";